import { DISPATCH_HIDE_MODAL } from '@/src/common/reducers/constants'
import { ModalButtonsWrapper } from '@/src/common/components/elements/Modals/StyledModalComponents'
import Button from '@/src/common/components/marketing/buttons/Button'
import { CardPreview } from '@/src/card-linking/components/CardPreview'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons/faCircleCheck'
import { styled, theme } from '@/src/stitches.config'
import { GradientText } from '@/src/modules/pg-plus/PGPlusStyledComponents'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { beat } from '@/src/common/animations'
import { usePGPlusStepAndModalContext } from '@/src/common/contexts/PGPlusModalAndStepContext'
import { SuccessCheck } from '@/src/common/components/elements/Animations/SuccessCheck'

type TCardLinkModalProps = {
    cardNetwork: string
    cardLastFour: string
    disableButton: boolean
    isDeleteLoading: boolean
    dispatch: Function
    deleteCard: Function
    deleteIsSuccess: boolean
}

const UnenrollCardModalContent = ({
    cardLastFour,
    cardNetwork,
    dispatch,
    deleteCard,
    disableButton,
    isDeleteLoading,
    deleteIsSuccess,
}: TCardLinkModalProps) => {
    const { giftState } = usePGPlusStepAndModalContext()
    const { cardUuid } = giftState
    if (deleteIsSuccess) {
        return (
            <div style={{ textAlign: 'center' }}>
                <SuccessCheck
                    icon={faCircleCheck}
                    style={{ display: 'block' }}
                    fontSize={'5rem'}
                    color={`${theme.colors.success}`}
                />
                <GradientText
                    size={'sm'}
                    as={'p'}
                    style={{ fontSize: '1.5rem', margin: '10px 0px 30px' }}
                >
                    Your card has been deleted.
                </GradientText>
                <p>
                    To use this gift, please link a new credit or debit card, or
                    select another redemption method.
                </p>
            </div>
        )
    }

    return (
        <div style={{ width: '100%' }}>
            <h3 style={{ margin: 0 }}>Delete Activation Card</h3>
            <p>
                If you delete this card, you will not receive credit for future
                purchases made on this card. You can add a new card to be used
                for activation at anytime.
            </p>
            <p>Deleting will affect all gifts activated to this card.</p>
            <CardPreview
                cardId={''}
                cardNetwork={cardNetwork}
                cardLastFour={cardLastFour}
                style={{ width: '100%' }}
                labelStyle={{ gap: 5 }}
            />
            <ModalButtonsWrapper>
                <Button
                    label={'Delete Saved Card'}
                    onClick={() => {
                        deleteCard({ card_uuid: cardUuid, payment_card_id: '' })
                    }}
                    variant={'primary'}
                    textTransform={'uppercase'}
                    width={'full'}
                    data-testid={'remove-card-button'}
                    size={'sm'}
                    isLoading={isDeleteLoading}
                    disabled={disableButton}
                    showArrow={true}
                />
                <Button
                    label={'Cancel'}
                    onClick={() => dispatch({ type: DISPATCH_HIDE_MODAL })}
                    variant={'primaryOutline'}
                    textTransform={'uppercase'}
                    width={'full'}
                    data-testid={'cancel-button'}
                    size={'sm'}
                    disabled={disableButton}
                    showArrow={true}
                />
            </ModalButtonsWrapper>
        </div>
    )
}

export default UnenrollCardModalContent
